export default __webpack_public_path__ + "assets/Lato-BoldItalic.fd32b4dea61508c37b78d0c42a33bb74.ttf";